import { render, staticRenderFns } from "./SimuVillageHostAdmin.vue?vue&type=template&id=4c2bf8fa&scoped=true"
import script from "./SimuVillageHostAdmin.vue?vue&type=script&lang=js"
export * from "./SimuVillageHostAdmin.vue?vue&type=script&lang=js"
import style0 from "./SimuVillageHostAdmin.vue?vue&type=style&index=0&id=4c2bf8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2bf8fa",
  null
  
)

export default component.exports